import React from 'react';
import PropTypes from 'prop-types';
import ProductIdFilter from 'components/form/filters/ProductIdFilter';
import TextFilter from 'components/list/Filters/types/TextFilter';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';

const NameFilter = <TextFilter
    label='filters.components.name.label'
    source='name'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
/>;

const ProductMembershipListFilters = (props) => {
    const filters = {
        basic: {
            name: {
                component: NameFilter,
                label: 'filters.components.name.label',
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },

            },
            product_id: {
                component: ProductIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
        advanced: {
            name: {
                component: NameFilter,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            product_id: {
                component: ProductIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

ProductMembershipListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default ProductMembershipListFilters;



// WEBPACK FOOTER //
// ./src/pages/product-memberships/list/ProductMembershipListFilters.js